import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Breakpoint, ScreenSize } from "@arcteryx/components-typography";
import { FilterTitle } from "@arcteryx/components-filterbar";
import { FilterRefinementList } from "./FilterRefinementList";

const RefineCategoryTitle = styled(props => <FilterTitle {...props}/>)`
  width: 50%;
  ${Breakpoint("sm")`
    width: 40%
  `}
  ${Breakpoint("lg")`
    width: initial;
  `} 
  @media only screen and (min-width: calc(${ScreenSize.xl}px + 1px)) {
    display: none;
  }

  .filter-title-label {
    ${(props) => (props.refineFacetSelected ? `text-decoration: underline;` : "")}
  }
`;

const RefineDropdownContainer = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  max-height: 0;
  opacity: 0;
  pointer-events: none;
  background-color: var(--white);
  position: absolute;
  z-index: 2;
  top: 2.34rem;
  left: 0;
  @media only screen and (min-width: calc(${ScreenSize.xl}px + 1px)) {
    position: relative;
    top: 0;
    max-width: 40ch;
    flex-direction: row;
    justify-content: space-between;
    max-height: 100%;
    opacity: 1;
    pointer-events: auto;
  }
  &:before {
    content: "";
    background-color: var(--white);
    width: 5000%;
    height: 100%;
    position: absolute;
    left: -500%;
    top: 0;
    z-index: 3;
  } 

  .arc-Filter {
    opacity: 0;
    pointer-events: none;
    position: relative;
    @media only screen and (min-width: calc(${ScreenSize.xl}px + 1px)) {
      opacity: 1;
      pointer-events: auto;
    }

    @media screen and (max-width: ${ScreenSize.xl}px) {
      &:first-of-type {
        .filter-title {
          span {
            border-top-width: 0;
          }
        }
      }

      &:last-of-type {
        .filter-title {
          border-bottom: 0.066rem solid var(--colour-grey-pinline);
        }
      }
    }
  }

  &.activeCategory, &.activeFilter {
    max-height: 107.333rem;
    opacity: 1;
    pointer-events: auto;
    ${Breakpoint("xl")`
      max-height: 100rem;
    `}
    .arc-Filter {
      opacity: 1;
      pointer-events: auto;
    }
  }
`;

export const FilterRefineCategory = ({
  facets = [], 
  selectedFacets,
  activeCategory,
  activeFilters,
  ...props
}) => {
  const [ refineFacetSelected, setRefineFacetSelected ] = useState(false);
  const { handleSetActiveCategory, handleSetActiveFilters } = props;
  const { t } = useTranslation("container-search");
  const catId = "refine";
  const label = t("Refine");
  const isRefineActive = activeCategory === catId;

  // this useEffect checks the selectedFacets to see if there are any active
  // and then sets the state of refineFacetSelected as true or false
  // this controls the underline of the "Refine" filter title
  useEffect(() => {
    for (const [key, value] of Object.entries(selectedFacets)) {
      if (Array.isArray(value) && value.length) {
        setRefineFacetSelected(true);
      } else {
        setRefineFacetSelected(false);
      }
    }
  }, [selectedFacets]);

  const handleRefineChange = () => {
    handleSetActiveFilters(isRefineActive ? null : catId);
    handleSetActiveCategory(isRefineActive ? null : catId);
  };

  return (
    <>
      <RefineCategoryTitle 
        catId={catId}
        label={label}
        isActive={isRefineActive} 
        className={"filter-category-title"}
        refineFacetSelected={refineFacetSelected}
        handleCategoryChange={handleRefineChange}
      />
      <RefineDropdownContainer
        className={`${activeCategory && activeCategory !== "sort" ? "activeCategory" : ""}`}
      >
        {facets?.map(({name}) => {
          return (
            <FilterRefinementList
              key={name}
              attribute={name}
              isActive={activeFilters === name}
              limit={100}
              {...props}
            />
          )
        })}
      </RefineDropdownContainer>
    </>
  )
};